import { Component, EventEmitter, input, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormsModule } from '@angular/forms';
import { Listbox, ListboxChangeEvent } from '@openng/optimus-ui/listbox';
import { Subscription } from 'rxjs';
import { SearchInputComponent } from '../../../../../components/kit/input/text-input/search-input.component';
import { Popover } from '@openng/optimus-ui/popover';
import { TranslatePipe } from '@ngx-translate/core';
import { SafeHtmlPipe } from '../../../pipes/safe-html.pipe';
import { Divider } from '@openng/optimus-ui/divider';
import { ButtonComponent } from '../../../../../components/kit/button/button.component';

@Component({
    selector: 'app-input-fulltext',
    templateUrl: 'input-fulltext.component.html',
    styleUrls: ['./input-fulltext.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        SearchInputComponent,
        Popover,
        Listbox,
        TranslatePipe,
        SafeHtmlPipe,
        Divider,
        ButtonComponent,
        FormsModule,
    ],
})
export class InputFulltextComponent implements OnInit, OnDestroy {
    @Input() label = '';
    public options = input<(IOption | any)[]>([]);
    @Input({ required: true }) form!: FormGroup;
    @Output() selectedOptionChange = new EventEmitter<IOption | null>();

    subs: Subscription[] = [];

    searchOptions: IOption[] = [];

    selectedOptionSearch: object | null = null;

    selectedOptionSearchData: string = '';

    ngOnInit(): void {
        this.subs.push(
            this.form.valueChanges.subscribe(({ search }) => {
                this.selectedOptionSearch = null;
                this.selectedOptionSearchData = '';

                this.searchOptions = this.options().filter((item: IOption) => {
                    if (!search) return false;

                    const reg = new RegExp(search.toLowerCase().replace('\\', '\\\\'), 'gi');
                    const rawText = new DOMParser().parseFromString(item.data, 'text/html').body.textContent || '';
                    if (!rawText.matchAll(reg).next()?.value) return false;

                    if (!this.selectedOptionSearch) {
                        this.selectedOptionSearch = item;
                        this.selectedOptionSearchData = this.replateMatchByBold(item.data, search);
                    }

                    return true;
                });
            }),
        );
    }

    accept(): void {
        this.selectedOptionChange.emit(this.selectedOptionSearch as IOption);
    }

    listSearchChange(index: ListboxChangeEvent): void {
        if (index.value?.index === undefined) return;

        this.selectedOptionSearch = this.options()[index.value.index];
        this.selectedOptionSearchData = this.replateMatchByBold(this.options()?.[index.value.index]?.['data'] || '', this.form.value.search);
    }

    ngOnDestroy(): void {
        this.subs.forEach((sub) => sub.unsubscribe());
    }

    private replateMatchByBold(text: string, _search: string): string {
        const search = _search
            .replace('<', '')
            .replace('>', '')
            .replace('\\', '\\\\')
        ;
        if (!search.length) return text;

        return text.replace(
            new RegExp(`${search}(?![^<]*?>)` as string, 'gi'),
            (match) => {
                return `<b>${match}</b>`;
            },
        );
    }
}

export interface IOption {
    data: string;
    createdAt: string;
    index: number;
}
